var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.proceed.apply(null, arguments)
        },
        keydown: function($event) {
          return _vm.annualReturnForm.errors.clear($event.target.name)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _vm.userRole != "user"
          ? _c("div", { staticClass: "col-xl-12 col-md-6 col-12" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Tax Payer")]),
                  _vm._v(" "),
                  _c("v-select", {
                    class: {
                      "form-control is-invalid": _vm.annualReturnForm.errors.has(
                        "user_id"
                      )
                    },
                    attrs: {
                      options: _vm.taxPayers,
                      reduce: function(name) {
                        return name.id
                      },
                      label: "name",
                      name: "user_id"
                    },
                    model: {
                      value: _vm.annualReturnForm.user_id,
                      callback: function($$v) {
                        _vm.$set(_vm.annualReturnForm, "user_id", $$v)
                      },
                      expression: "annualReturnForm.user_id"
                    }
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.annualReturnForm,
                      "prop-name": "user_id"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-12 col-md-6 col-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [
                _vm._v(_vm._s(_vm.trans("annual_return.year_of_return")))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.annualReturnForm.year_of_return,
                    expression: "annualReturnForm.year_of_return"
                  }
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.annualReturnForm.errors.has(
                    "year_of_return"
                  )
                },
                attrs: {
                  type: "text",
                  value: "",
                  name: "year_of_return",
                  placeholder: _vm.trans("annual_return.year_of_return")
                },
                domProps: { value: _vm.annualReturnForm.year_of_return },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.annualReturnForm,
                      "year_of_return",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.annualReturnForm,
                  "prop-name": "year_of_return"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-12 col-md-6 col-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [
                _vm._v(_vm._s(_vm.trans("annual_return.annual_turnover")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-5" }, [
                _c("div", { staticClass: "input-group" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.annualReturnForm.annual_turnover,
                        expression: "annualReturnForm.annual_turnover"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.annualReturnForm.errors.has(
                        "annual_turnover"
                      )
                    },
                    attrs: {
                      type: "text",
                      value: "",
                      name: "annual_turnover",
                      placeholder: _vm.trans("annual_return.annual_turnover")
                    },
                    domProps: { value: _vm.annualReturnForm.annual_turnover },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.annualReturnForm,
                          "annual_turnover",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.annualReturnForm,
                  "prop-name": "annual_turnover"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-12 col-md-6 col-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [
                _vm._v(_vm._s(_vm.trans("annual_return.date")))
              ]),
              _vm._v(" "),
              _c("datepicker", {
                class: {
                  "form-control is-invalid": _vm.annualReturnForm.errors.has(
                    "date"
                  )
                },
                attrs: {
                  bootstrapStyling: true,
                  placeholder: _vm.trans("admission.date")
                },
                on: {
                  selected: function($event) {
                    return _vm.annualReturnForm.errors.clear("date")
                  }
                },
                model: {
                  value: _vm.annualReturnForm.date,
                  callback: function($$v) {
                    _vm.$set(_vm.annualReturnForm, "date", $$v)
                  },
                  expression: "annualReturnForm.date"
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.annualReturnForm,
                  "prop-name": "date"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("file-upload-input", {
              attrs: {
                "button-text": "Chose File",
                token: _vm.annualReturnForm.upload_token,
                module: "annual_return",
                "clear-file": _vm.clear_message_attachment,
                "module-id": _vm.annualReturnForm.id,
                "has-file-type": true
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-8 offset-md-4" },
          [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right",
                attrs: { type: "submit" }
              },
              [
                _vm.id
                  ? _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))])
                  : _c("span", [_vm._v(_vm._s(_vm.trans("general.save")))])
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass:
                  "btn btn-danger waves-effect waves-light pull-right mr-1 mb-1",
                attrs: { to: "/annual-return" }
              },
              [_vm._v(_vm._s(_vm.trans("general.cancel")) + "\n            ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-addon" }, [
      _c("h4", { staticStyle: { "margin-top": "5px", padding: "0px 5px" } }, [
        _vm._v("₦")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }